// extracted by mini-css-extract-plugin
export var container = "news-module--container--Ni6uv";
export var content = "news-module--content--nwoLV";
export var description = "news-module--description--DDwwS";
export var item = "news-module--item--0WRtf";
export var itemTitle = "news-module--item-title--V72u0";
export var subHeading = "news-module--sub-heading--192d-";
export var title = "news-module--title--TLY7p";